/**
 * ImpersonationBanner — barra persistente "Modo teste" (Parte 3 / F3).
 *
 * Aparece no topo de um portal (cliente/terceiro) quando a sessão é uma
 * impersonação (o /me devolveu `impersonatedBy`). "Sair" encerra a sessão do
 * portal (logout) e volta pro admin. ZERO localStorage — o estado vem do cookie
 * de sessão (claim `impersonatedBy`), não do client.
 */
interface ImpersonationBannerProps {
  /** Nome do alvo que está sendo visto (ex.: o cliente ou o terceiro). */
  alvoNome: string;
  /** Encerra a impersonação (logout do portal) e volta pro admin. */
  onSair: () => void;
  saindo?: boolean;
}

export function ImpersonationBanner({ alvoNome, onSair, saindo }: ImpersonationBannerProps) {
  return (
    <div
      className="sticky top-0 z-50 flex items-center justify-between gap-3 px-4 py-2 bg-warning/15 border-b border-warning/40 text-sm text-ink-1 dark:text-ink-dark-1"
      role="status"
      data-testid="impersonation-banner"
    >
      <span>
        🔬 <strong>Modo teste</strong> — você está vendo como <strong>{alvoNome}</strong>.
      </span>
      <button
        type="button"
        onClick={onSair}
        disabled={saindo}
        className="shrink-0 rounded-md border border-warning/50 px-3 py-1 text-xs font-medium hover:bg-warning/20 disabled:opacity-50"
        data-testid="impersonation-sair"
      >
        Sair do modo teste
      </button>
    </div>
  );
}
